// #/services/workspaces/getWorkspaces.ts

import { join as pathJoin } from 'path';
import compact from 'lodash/compact';

import { AWS_S3_BUCKET } from '#/config/constants';
import { s3 } from '#/services/s3';
import readJsonFile from '#/services/s3/actions/json/readJsonFile';
import { IWorkspace } from '#/types/workspace';
import { PATH_USERS } from '../s3/filepaths';

function isJsonPath(path: string | any) {
  return typeof path === 'string' && path.endsWith('.json');
}

function isWorkspacePath(path: string | any) {
  return (
    isJsonPath(path) &&
    /0x[a-zA-Z0-9]+\/workspaces\/[a-zA-Z0-9-]+\.json/g.test(path ?? '')
  );
}

export default async function getWorkspaces(args: {
  ownerAddress: string;
}): Promise<IWorkspace[]> {
  try {
    const { ownerAddress } = args;

    // console.info('getWorkspaces(', JSON.stringify(args), ')');

    const userHome = pathJoin(PATH_USERS, ownerAddress);
    const userWorkspacesFolderKey = pathJoin(userHome, 'workspaces/');

    const objects = await s3
      .listObjects({ Bucket: AWS_S3_BUCKET, Prefix: userWorkspacesFolderKey })
      // TODO
      // .listObjectsV2({
      //   Bucket: AWS_S3_BUCKET,
      //   Prefix: folderKey,
      //   Delimiter: '/',
      // })
      .promise();

    const workspaceKeys: string[] = [];
    for (const content of objects.Contents ?? []) {
      if (content?.Key != null && isWorkspacePath(content?.Key)) {
        workspaceKeys.push(content?.Key);
      }
    }

    const workspaces: any[] = compact(
      await Promise.all(
        workspaceKeys.map(async (workspaceKey) => {
          try {
            return await readJsonFile<IWorkspace>({
              s3ObjectKey: workspaceKey,
            });
          } catch (error: any) {
            console.error(
              `Error fetching workspace JSON ${workspaceKey}: ${error.message}`,
            );
          }
        }),
      ),
    );

    return workspaces;
  } catch (error: any) {
    console.error(error);
    console.error(`Error getting workspaces: ${error.message}`);
    // throw new Error(`Error getting workspaces: ${error.message}`);
    return [];
  }
}
